var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoordinatoricon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33366 12.25V11.0833C9.33366 10.4645 9.08783 9.871 8.65024 9.43342C8.21266 8.99583 7.61916 8.75 7.00033 8.75H3.50033C2.88149 8.75 2.28799 8.99583 1.85041 9.43342C1.41282 9.871 1.16699 10.4645 1.16699 11.0833V12.25",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#4F46E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 1.82812C9.83337 1.95784 10.2765 2.25003 10.5928 2.65883C10.9092 3.06763 11.0808 3.56989 11.0808 4.08679C11.0808 4.60369 10.9092 5.10596 10.5928 5.51476C10.2765 5.92355 9.83337 6.21574 9.33301 6.34546",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#4F46E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 12.2523V11.0856C12.8326 10.5686 12.6605 10.0664 12.3438 9.65781C12.0271 9.24921 11.5836 8.95737 11.083 8.82812",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#4F46E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58366 4.08333C7.58366 5.372 6.53899 6.41667 5.25033 6.41667C3.96166 6.41667 2.91699 5.372 2.91699 4.08333C2.91699 2.79467 3.96166 1.75 5.25033 1.75C6.53899 1.75 7.58366 2.79467 7.58366 4.08333Z",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoordinatoricon);
export default __webpack_public_path__ + "static/media/coordinatoricon.d8c59641b2b0666246e4c1cb8be0ffd8.svg";
export { ForwardRef as ReactComponent };